import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";

import { API_DATA_CENTER_LIST } from "../../../service/url";
import {
  SERVER_MANAGEMENT_DOMESTIC_TYPE,
  SERVER_MANAGEMENT_INTERNATIONAL,
  SERVER_TYPES,
} from "../../../utilities/constant";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import { postApiMediaCall } from "../../../service/postApiCall";

export default function RenderServerManagementForm(props) {
  const [dataCenterList, setDataCenterList] = useState([]);

  useEffect(() => {
    getApiCall(API_DATA_CENTER_LIST, {})
      .then(onDataCenterListSuccess)
      .catch(onError);
  }, []);

  function onDataCenterListSuccess(resp) {
    setDataCenterList(resp);
  }

  function onError(err) {
    console.log(err);
  }
  return (
    <>
      <div className="row">
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="status">Select Data Center:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Select
            id="dataCenter_Id"
            required
            value={props.dataCenterId}
            className="p-2"
            onChange={(e) => props.setDataCenterId(e.target.value)}
          >
            <option value={""}>Select Data Center</option>
            {dataCenterList.map(function (val, idx) {
              return (
                <option key={idx} value={val.id}>
                  {val.name}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="status">Select Gateway Type:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Select
            id="dataServer_type"
            value={props.serverType}
            className="p-2"
            onChange={(e) => props.setServerType(e.target.value)}
          >
            <option value={""}>Select Gateway Type</option>
            {SERVER_TYPES.map(function (val, idx) {
              return (
                <option key={idx} value={val.value}>
                  {val.label}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
      </div>

      <div className="row">
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="status">Gateway IP:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Control
            type="text"
            id="server_ip"
            value={props.serverIP}
            placeholder="Gateway IP"
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9.]/g, "");
              props.setServerIP(value);
            }}
          />
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="status">Gateway Name:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Control
            type="text"
            id="server_name"
            value={props.serverName}
            placeholder="Gateway Name"
            onChange={props.handleChange}
          />
          {props.error && <small style={{ color: "red" }}>{props.error}</small>}
        </Form.Group>
      </div>
      <div className="row">
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && */}
           <Form.Label htmlFor="status">OS:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Control
            type="text"
            id="os"
            value={props.OS}
            placeholder="OS"
            onChange={(e) => props.setOS(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="status">CPU Cores:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}

          <Form.Control
            type="text"
            id="cpu_cores"
            value={props.CPUCores}
            placeholder="CPU Cores"
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              props.setCPUCores(value);
            }}
          />
        </Form.Group>
      </div>
      <div className="row">
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode &&  */}
          <Form.Label htmlFor="status">RAM:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* } */}
          <Form.Control
            type="text"
            id="ram"
            value={props.RAM}
            placeholder="RAM"
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              props.setRAM(value);
            }}
          />
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="status">Hard Disk:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}

          <Form.Control
            type="text"
            id="hard_disk"
            value={props.hardDisk}
            placeholder="Hard Disk"
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              props.setHardDisk(value);
            }}
          />
        </Form.Group>
      </div>
    </>
  );
}
